import * as Yup from 'yup';
import getLangData from '../../../../utils/getLangData';

const schema = () =>
  Yup.object().shape({
    name: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    namei18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default(''),
    }),

    tags: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    productID: Yup.string().default(''),
    supplierCID: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    description: Yup.string().default(''),
    metaKeywords: Yup.string().default(''),
    material: Yup.string().default(''),
    // colors: Yup.array().of(Yup.string().default('')).max(5),
    colors: Yup.string().default(''),
    size: Yup.string().default(''),
    usage: Yup.string().default(''),
    packed: Yup.bool().default(false),
    packingDetails: Yup.string().default(''),

    shippableLocal: Yup.bool().default(false),
    shippableInter: Yup.bool().default(false),

    productionTime: Yup.string().default(''),
    // priceRange: Yup.string().default(""),
    priceFrom: Yup.string().default(''),
    priceTo: Yup.string().default(''),
    discounted: Yup.bool().default(false),
    discount: Yup.string().default('').nullable(),
    offerExpires: Yup.string().default('').nullable(),

    hasBuyNowLink: Yup.bool().default(false),
    buyNowLink: Yup.string().default(''),
    video: Yup.string().default(''),
    descriptioni18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default(''),
    }),
    /* productImages : Yup.array.of() */
  });

export default schema;
